import { forBrand, environment, forLocale, Configurable } from "@crystal/config";
const idpHostEU = forBrand({
  adidas: environment({
    production: "https://eu.idp.adidas.com",
    default: "https://eu.idp.stg.adidas.com"
  }),
  reebok: environment({
    production: "https://eu.idp.reebok.com",
    default: "https://eu.idp.stg.reebok.com"
  })
});
const idpHostUS = forBrand({
  adidas: environment({
    production: "https://us.idp.adidas.com",
    default: "https://us.idp.stg.adidas.com"
  }),
  reebok: environment({
    production: "https://us.idp.reebok.com",
    default: "https://us.idp.stg.reebok.com"
  })
});
const externalAuthServer = forLocale({
  AR: idpHostUS,
  BR: idpHostUS,
  CA: idpHostUS,
  CL: idpHostUS,
  CO: idpHostUS,
  MX: idpHostUS,
  PE: idpHostUS,
  US: idpHostUS
}).defaults(idpHostEU);
const externalAuthConfig = Configurable.props({
  externalAuthServer,
  clientId: forBrand({
    adidas: environment({
      production: "RL9WSN7S44DEBL3B2JN5KKZF4EPEMVJC",
      default: "4DNKT1DHVT5N010LF7RVXZPECU7O3BOQ"
    }),
    reebok: environment({
      production: "FR3WH1R7F8WRA7LZPCLJRQALRTWT7FXC",
      default: "TURD32LFACVLT8HBATQDSX8N0KXJAODH"
    })
  }),
  persistentClientId: forBrand({
    adidas: environment({
      production: "LUJ5J74JY3NJDFZ0GTAOSTU5PRJY2Q57",
      default: "OTYNSQFGLOH0K6PEKRCYBH6SHVSV6CBO"
    }),
    reebok: environment({
      production: "RLJOYW8JX1MACM1YVI11OX4VRS9WBCXF",
      default: "U3KYKNV4OCCWS7F998K42DPO1O7BBOGT"
    })
  }),
  // AIC supported providers, https://confluence.tools.3stripes.net/x/9rUrEw
  providers: forBrand({
    adidas: {
      facebook: {
        name: "facebook",
        adapter: "facebookAdiComposite"
      },
      google: {
        name: "google",
        adapter: "googleAdiComposite"
      },
      apple: {
        name: "apple",
        adapter: "appleAdiComposite"
      },
      yahoo: {
        name: "yahoo",
        adapter: "yahooAdiComposite"
      },
      kakao: {
        name: "kakao",
        adapter: "kakaotalkAdiComposite"
      },
      kmc: {
        name: "kmc",
        adapter: "kmcAdi"
      },
      vk: {
        name: "vk",
        adapter: "vkAdiComposite"
      },
      naver: {
        name: "naver",
        adapter: "naverAdiComposite"
      }
    },
    reebok: {
      facebook: {
        name: "facebook",
        adapter: "facebookRbkComposite"
      },
      google: {
        name: "google",
        adapter: "googleRbkComposite"
      },
      yahoo: {
        name: "yahoo",
        adapter: "yahooRbkComposite"
      },
      vk: {
        name: "vk",
        adapter: "vkRbkComposite"
      }
    }
  })
});
export {
  externalAuthConfig
};
//# sourceMappingURL=config.js.map
